<template>
    <div class="embase">
        <div class="img_box">
            <img src="../../assets/embase/img/logo.png" alt="" />
        </div>
        <popupVal ref="popupVal1" :data="data" :defaultIndex="0" :value="'All Field'"> </popupVal>
        <popupVal ref="popupVal2" :data="data" :defaultIndex="1" :value="'Title'"> </popupVal>
        <popupVal ref="popupVal3" :data="data" :defaultIndex="2" :value="'Abstract'"> </popupVal>
        <popupVal ref="popupVal4" :data="data" :defaultIndex="3" :value="'Author name'"> </popupVal>
        <popupVal ref="popupVal5" :data="data" :defaultIndex="4" :value="'Author keywords'"> </popupVal>
        <div class="time">
            <div class="label">
                <span>开始年份:</span>
            </div>
            <van-field readonly clickable :value="yearStart" placeholder="开始年份" @click="year1 = true" />
            <van-popup v-model="year1" position="bottom">
                <van-picker show-toolbar :columns="currentDate" @cancel="year1 = false" @confirm="staetConfirm" />
            </van-popup>
        </div>
        <div class="time">
            <div class="label">
                <span>结束年份:</span>
            </div>
            <van-field readonly clickable :value="yearEnd" placeholder="结束年份" @click="year2 = true" />
            <van-popup v-model="year2" position="bottom">
                <van-picker show-toolbar :columns="currentDate" @cancel="year2 = false" @confirm="endConfirm" />
            </van-popup>
        </div>
        <van-button type="info" @click="retrieval">检索</van-button>
    </div>
</template>
<script>
import popupVal from "@/components/popupVal";
import { Toast } from "vant";
export default {
    name: "embase",
    data() {
        return {
            data: {
                "All Field": "all",
                Title: "ti",
                Abstract: "ab",
                "Author name": "au",
                "Author keywords": "kw",
                "Journal name": "jt"
            },
            boolData: {
                或: "OR",
                与: "AND",
                非: "NOT"
            },
            yearStart: "",
            yearEnd: "",
            year1: false,
            year2: false,
            currentDate: []
        };
    },
    mounted() {
        var time = new Date().getFullYear() - 1900;
        for (let i = 0; i < time; i++) {
            this.currentDate.push(new Date().getFullYear() - i);
        }
        this.$store.dispatch("actionsHead", { type: false, title: "", iconType: false });
    },
    methods: {
        staetConfirm(value) {
            if (value <= this.yearEnd || "" == this.yearEnd) {
                this.yearStart = value;
                this.year1 = false;
            } else {
                Toast("开始年份选择错误！");
            }
        },
        endConfirm(value) {
            if (value >= this.yearStart || "" == this.yearStart) {
                this.yearEnd = value;
                this.year2 = false;
            } else {
                Toast("结束年份选择错误！");
            }
        },
        retrieval() {
            var data = new Object();
            if (this.$refs.popupVal1.input != "") {
                data.input1 = this.$refs.popupVal1.input; //参数1
                data.sel1 = this.data[this.$refs.popupVal1.value]; //输入1
            }
            if (this.$refs.popupVal2.input != "") {
                data.input2 = this.$refs.popupVal2.input; //输入2
                data.sel2 = this.data[this.$refs.popupVal2.value]; //参数2
                // data.bool12 = this.boolData[this.$refs.popupVal2.bool];   //输入1和2间的逻辑连接
            }
            if (this.$refs.popupVal3.input != "") {
                data.input3 = this.$refs.popupVal3.input; //输入3
                data.sel3 = this.data[this.$refs.popupVal3.value]; //参数3
                // data.bool23 = this.boolData[this.$refs.popupVal3.bool];   //输入2和3间的逻辑连接
            }
            if (this.$refs.popupVal4.input != "") {
                data.input4 = this.$refs.popupVal4.input; //输入4
                data.sel4 = this.data[this.$refs.popupVal4.value]; //参数4
                // data.bool34 = this.boolData[this.$refs.popupVal4.bool];   //输入3和4间的逻辑连接
            }
            if (this.$refs.popupVal5.input != "") {
                data.input5 = this.$refs.popupVal5.input; //输入5
                data.sel5 = this.data[this.$refs.popupVal5.value]; //参数5
                // data.bool45 = this.boolData[this.$refs.popupVal5.bool];   //输入5和6间的逻辑连接
            }
            if (this.yearStart != "") {
                data.yearStart = this.yearStart; //年份开始
            }
            if (this.yearEnd != "") {
                data.yearEnd = this.yearEnd; //年份结束
            }
            this.$router.push({
                path: "/embaseList",
                query: data
            });
        }
    },
    components: {
        popupVal
    }
};
</script>
<style lang="less">
.embase {
    .van-fieldInp {
        width: 68%;
        float: left;
    }
    .img_box {
        height: 100px;
        margin-bottom: 1rem;
        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .time {
        margin-bottom: 0.5rem;
        overflow: hidden;
        line-height: 45px;
        span {
            font-size: 16px;
            margin-left: 9px;
        }
        .label {
            float: left;
            font-size: 14px;
            padding-left: 16px;
            width: 25%;
        }
        .van-cell--clickable {
            background: none;
            .van-field__control {
                background-size: 0.4rem;
                border-bottom: 1px solid #dadada;
                padding: 0 0.5rem;
                border-radius: 2px;
                font-size: 16px;
            }
        }
        .van-cell--clickable {
            width: 68%;
        }
    }
    > button {
        width: 85%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        margin: 2rem 0;
        background: #ef7b29;
        border-color: #ef7b29;
    }
}
</style>
